/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowLeagueV2 = {
    properties: {
        league: {
            type: 'IdElement',
            isRequired: true,
        },
    },
} as const;
